import classNames from 'classnames';
import React from 'react';
import PricingCheckIcon from './PricingCheckIcon';
import PricingModalLine from './PricingModalLine';
import * as styles from './PricingModalRow.module.scss';
import { PlanTier } from '../graphql/generated/graphql';

interface PricingRowProps {
  label?: JSX.Element | string;
  free?: string | boolean | JSX.Element;
  startup?: string | boolean | JSX.Element;
  business?: string | boolean | JSX.Element;
  type?: 'HEADER' | 'FOOTER' | 'CONTENT';
  activeTier: PlanTier;
  activeRow?: boolean;
}
const PricingModalRow = ({
  label,
  free,
  startup,
  business,
  type = 'CONTENT',
  activeTier,
  activeRow,
}: PricingRowProps) => {
  return (
    <div
      className={classNames(styles.pricingRow, {
        [styles.active]: activeRow,
        [styles.header]: type === 'HEADER',
        [styles.footer]: type === 'FOOTER',
      })}
    >
      <div className={styles.pricingRowLabel}>{label}</div>
      <div
        className={classNames(styles.pricingRowContent, {
          [styles.pricingRowActiveTier]: activeTier === PlanTier.Free,
        })}
      >
        {typeof free === 'boolean' ? (
          <>{free ? <PricingCheckIcon /> : <PricingModalLine />}</>
        ) : (
          free
        )}
      </div>
      <div
        className={classNames(styles.pricingRowContent, {
          [styles.pricingRowActiveTier]: activeTier === PlanTier.Startup,
        })}
      >
        {typeof startup === 'boolean' ? (
          <>{startup ? <PricingCheckIcon /> : <PricingModalLine />}</>
        ) : (
          startup
        )}
      </div>
      <div
        className={classNames(styles.pricingRowContent, {
          [styles.pricingRowActiveTier]: activeTier === PlanTier.Business,
        })}
      >
        {typeof business === 'boolean' ? (
          <>{business ? <PricingCheckIcon /> : <PricingModalLine />}</>
        ) : (
          business
        )}
      </div>
    </div>
  );
};

export default PricingModalRow;
